export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-20.314d9eb1.jpg";